var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-col-warp"},[_c('cg-row-control',{attrs:{"value":_vm.Value,"colInfo":_vm.colInfo,"recData":_vm.data},on:{"sortClick":_vm.OnSortClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }